import { render, staticRenderFns } from "./goodsPublish.vue?vue&type=template&id=328b1330&scoped=true"
import script from "./goodsPublish.vue?vue&type=script&lang=js"
export * from "./goodsPublish.vue?vue&type=script&lang=js"
import style0 from "./goodsPublish.vue?vue&type=style&index=0&id=328b1330&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328b1330",
  null
  
)

export default component.exports